<template>
  
  <div v-if='imageProperties.length > 0'>
        <b-dropdown id="dropdown-right" right text="Raw Files" variant="outline-default" size="sm" class="m-2 trigger-btn" no-caret >
            <template v-slot:button-content>
                  <b-icon icon="cloud-download"  variant="success" aria-hidden="true"></b-icon>
                </template>
            <b-dropdown-item @click.prevent="downloadFileFromServer(itemName, orderNo,  property.value, printedText)" href="#" v-for="(property, index) in imageProperties" :key="index" class="previewParent">Raw File {{ index + 1}}
                
               <div class="preview">
                 <b-img-lazy :src="getThumbImageUrl(property)" alt="Customer Raw File"></b-img-lazy>
               </div>
              
            </b-dropdown-item>
        </b-dropdown>
         <b-spinner label="Spinning"  small v-show="downloadInProgress"></b-spinner>
  </div>
</template>

<script>
import DownloadFileMixin from './mixins/download-file.mixin'
const pluginInitial = ["uploadery", "direct link"];
// -/resize/300x/
  export default {
      data(){
        return {
          downloadInProgress: false
        }
      },
      props: ['properties', 'itemName', 'orderNo'],
      mixins:[DownloadFileMixin],
      methods: {
         getThumbImageUrl(property){
              if(property.name.includes('uploadery')){
                  return `${this.getBase(property.value)}preview_${property.value.split('/').pop()}`
              }else if(property.name.includes('direct link')){
                  return property.value;
              }
         }  
      },
      computed: {
         imageProperties(){
            const imgProps = this.properties.filter(property => {

                for(let i=0; i < pluginInitial.length; i++){
                    if(property.name.includes(pluginInitial[i])){
                      return true;
                    } 
                }
            })
            return imgProps
         },
         printedText(){
            const printedText = this.properties.find(property => property.name.toLowerCase().includes('printed text'))
            if(printedText){
               return printedText.value;
            }else{
              return null;
            }
         }
      }
  }
</script>

<style lang="scss" scoped>
  .preview{
    position: absolute;
    left: -210px;
    top: 0;
    max-width: 200px;
    z-index: 10;
    transform: translate(0, -100%);
    img{
      max-width: 100%;
      height: auto;
      border: 5px solid #fff;
      box-shadow: 3px 3px 5px rgba(0,0,0, 0.2);
      opacity: 0;
      transition: opacity 0.2s ease-in
    }
  }
  .previewParent:hover{
      img{
        opacity: 1;
      }
  }

  .trigger-btn{
    color: red;
  }
</style>